<template>
  <validation-observer v-slot="{ touched }">
    <div :class="['interview-input-group', touched ? 'touched':'']">
      <div class="pb-0 pl-3 pr-3 mt-0 pt-2 interview-card-container">
        <b-row align-v="center" class="ml-0 mr-0">
          <b-col col lg="3" class="pl-0 pr-0">
            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`name${indexAt}`"
                type="text"
                v-model="candidate.name"
                :disabled="!isEditable"
                :name="resource['hrvenue.createCandidate.Name']"
                rules="required|min:2|validChar"
                :placeholder="resource['hrvenue.candidateNamePlaceholder']"
                @keypress="maxLengthCheck($event, 75, 'name')"
                @keyup="maxLengthCheck($event, 75, 'name')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched':'untouched'"
              >
              </validate-form>
          </validation-observer>
          </b-col>
          <b-col col lg="3">
            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`surname${indexAt}`"
                :name="resource['hrvenue.createCandidate.Surname']"
                v-model="candidate.surname"
                type="text"
                :disabled="!isEditable"
                rules="required|min:2||validChar"
                :placeholder="resource['hrvenue.candidateSurNamePlaceholder']"
                @keypress="maxLengthCheck($event, 75, 'surname')"
                @keyup="maxLengthCheck($event, 75, 'surname')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched':'untouched'"
              >
              </validate-form>
            </validation-observer>
          </b-col>
          <b-col class="pr-0">
            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`email${indexAt}`"
                :name="resource['hrvenue.createCandidate.Email']"
                v-model="candidate.email"
                type="text"
                :disabled="!isEditable"
                rules="onlyEnglishLetters|required|min:10|max:300|emailRegex"
                :placeholder="resource['hrvenue.candidateEmailPlaceholder']"
                @keypress="maxLengthCheck($event, 300, 'email')"
                @keyup="maxLengthCheck($event, 300, 'email')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched':'untouched'"
              >
              </validate-form>
          </validation-observer>
          </b-col>
          <span
              v-if="showDeleteButton"
              @click="clickDelete"
              :id="`delete${indexAt}FormInput`"
              :name="`delete${indexAt}`"
              class="cursor-pointer float-right trash-icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M9 1.5C4.8525 1.5 1.5 4.8525 1.5 9C1.5 13.1475 4.8525 16.5 9 16.5C13.1475 16.5 16.5 13.1475 16.5 9C16.5 4.8525 13.1475 1.5 9 1.5ZM12.225 12.225C11.9325 12.5175 11.46 12.5175 11.1675 12.225L9 10.0575L6.8325 12.225C6.54 12.5175 6.0675 12.5175 5.775 12.225C5.4825 11.9325 5.4825 11.46 5.775 11.1675L7.9425 9L5.775 6.8325C5.4825 6.54 5.4825 6.0675 5.775 5.775C6.0675 5.4825 6.54 5.4825 6.8325 5.775L9 7.9425L11.1675 5.775C11.46 5.4825 11.9325 5.4825 12.225 5.775C12.5175 6.0675 12.5175 6.54 12.225 6.8325L10.0575 9L12.225 11.1675C12.51 11.4525 12.51 11.9325 12.225 12.225Z" fill="#353535"/>
              </svg>
            </span>
        </b-row>
      </div>
    </div>
  </validation-observer>
</template>

<script>
export default {
  name: 'interviewCardItem',

  props: {
    candidate: { type: Object, required: true },
    isEditable: { type: Boolean, default: true },
    indexAt: { type: Number },
    isDelete: { type: Boolean, default: true },
    order: {
      type: Number,
      required: true,
    },
    totalCandidateCount: {
      type: Number,
      required: true,
    },
  },

  components: {},

  data() {
    return {
      amount: 7800,
    };
  },
  computed: {
    showLine() {
      return this.isEditable && this.order < this.totalCandidateCount - 1;
    },

    showDeleteButton() {
      //* Eger ilk soru degilse silmeyi goster
      if (this.isDelete) {
        return this.totalCandidateCount > 1;
      }
      return false;
    },
  },

  mounted() {
  },

  created() {
    this.candidate.order = this.order + 1;
  },
  methods: {
    checkValidateRule() {
      this.$emit('onCheckValidRule', this.candidate);
    },
    clickDelete() {
      if (this.isDelete) {
        this.$emit('onDeleteQuestion', this.order);
      }
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'name') {
        this.candidate.name = value;
      } else if (InpEl === 'surname') {
        this.candidate.surname = value;
      } else {
        this.candidate.email = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (!maxLength || String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';
::v-deep .untouched{
  &.has-danger .form-control {
    border-color: #e6e6e6 !important;
    color:black !important;
    @include box-shadow(inset 0 0 0 1px #e6e6e6 !important);
  }
}
.job-list {
  min-height: 300px;
}
::v-deep .interview-card-container {
    .form-control-feedback{
      display: none !important;
    }
}

.trash-icon{
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 12px;
}
.user-filter {
  display: flex;
  align-items: center;
  position: relative;

  & .multiselect {
    font-size: 13px;
    & .multiselect__select:before {
      top: 60%;
    }

    & .multiselect__input,
    .multiselect__single {
      vertical-align: unset !important;
    }

    & .multiselect__option {
      display: flex;

      & span {
        width: 180px;
        text-overflow: ellipsis;
        overflow: hidden;

        @include media-breakpoint-down(sm) {
          width: 120px;
        }
        @include media-breakpoint-down(lg) {
          width: 140px;
        }
        @include media-breakpoint-down(xl) {
          width: 180px;
        }
      }
    }
  }
  & i {
    font-size: 16px;
    margin-left: 8px;
    position: absolute;
    right: 24px;
    z-index: 1;
  }
}

.pb-50vh {
  padding-bottom: 50vh;
}

.fs-14 {
  // position: absolute;
  // right: 16px;
  font-size: 14px !important;
  margin-left: 8px;
}

.secret-job {
  background: rgba(0, 0, 0, 0.12);
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.38);
  margin-left: 8px;
  font-weight: bold;
}

.dragIcon {
  cursor: move;
  color: #c2c2c2;
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  padding: 4px;
  gap: 10px;
  padding-bottom: 0;

  &:hover {
    background-color: #FF8D06;
    border-color: #FF8D06;
    color: white;
  }
}

.questionLine {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: -webkit-center;
  zoom: 1;
  & div {
    border: 1px solid #FF8D06;
    background-color: #FF8D06;
    width: 496px;
    height: 1px;
  }
}
@media (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 1.5) and (-webkit-max-device-pixel-ratio: 1.99){
  .questionLine {
    zoom: 1.2;
  }
}
@media (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 2) and (-webkit-max-device-pixel-ratio: 2.5){
  .questionLine {
    zoom: .96;
  }
}
</style>
